import type { StockKanbanSupplyAvailableLotOption } from "./loadStockKanbanSupplyLotAvailability";

/** Режим размещения выбранной партии по остаткам в ячейках. */
export type StockKanbanSupplyLotCellPlacementMode = "idle" | "floor" | "single" | "multi";

/**
 * Определяет режим размещения партии по остаткам в ячейках:
 * `idle` — партия не выбрана; `floor` — без размещения; `single` — единственная ячейка;
 * `multi` — ячеек несколько, нужен ручной выбор.
 * @param lot выбранная партия с остатками по ячейкам
 */
export function resolveStockKanbanSupplyLotPlacementMode(
    lot: StockKanbanSupplyAvailableLotOption | null,
): StockKanbanSupplyLotCellPlacementMode {
    if (lot == null) {
        return "idle";
    }
    const { cells } = lot.availability;
    if (cells == null || cells.length === 0) {
        return "floor";
    }
    if (cells.length === 1) {
        return "single";
    }
    return "multi";
}

/**
 * `true`, когда партия размещена в ячейках (одна или несколько), но конкретная ячейка ещё не выбрана.
 * @param lot выбранная партия с остатками по ячейкам
 * @param spCode текущий код ячейки хранения
 */
export function isStockKanbanSupplyCellSelectionPending(
    lot: StockKanbanSupplyAvailableLotOption | null,
    spCode: number | null,
): boolean {
    if (lot == null || spCode != null) {
        return false;
    }
    const { cells } = lot.availability;
    return cells != null && cells.length > 0;
}
